<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="pagosCombustibleVehiculos"
	[displayWith]="displayPagoCombustibleVehiculos"
	[value]="selectedPagoCombustibleVehiculos"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
